/* vt.js — Sonnevia (copie italienne de la fiche vitanaturi.com, thème Shrine PRO) : ce que faisaient les scripts du thème et de
   l'appli Kaching, sans eux. Galerie + vignettes, choix de l'offre, ajout au carrello en VRAIE QUANTITÉ (la variante « 1 flacone » × N,
   une offre à la fois), tiroir panier en italien rempli depuis /cart.js, menu et recherche de l'en-tête, en-tête qui se cache en
   descendant (« on-scroll-up »). Les scripts propres aux sections (compte à rebours, carrousels, vidéos, bouton collant…) restent
   dans leurs sections, comme sur la source. */
(function () {
  'use strict';
  var CFG = window.vtConfig || {};
  var RACINE = (CFG.racine || '/').replace(/\/?$/, '/');
  var FORMAT = CFG.format || '€{{amount_with_comma_separator}}';

  function argent(cents) {
    cents = Math.round(cents || 0);
    function fmt(n, dec, mil, sep) {
      var s = (n / 100).toFixed(dec).split('.');
      s[0] = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, mil);
      return s[0] + (s[1] ? sep + s[1] : '');
    }
    return FORMAT.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount') return fmt(cents, 2, ',', '.');
      if (k === 'amount_no_decimals') return fmt(cents, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return fmt(cents, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return fmt(cents, 0, '.', ',');
      if (k === 'amount_with_apostrophe_separator') return fmt(cents, 2, "'", '.');
      return fmt(cents, 2, '.', ',');
    }).replace(/<[^>]+>/g, '');
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* ------------------------------------------------------------ galerie (media-gallery Shrine) */
  document.querySelectorAll('media-gallery').forEach(function (g) {
    var liste = g.querySelector('.product__media-list');
    if (!liste) return;
    var slides = [].slice.call(liste.querySelectorAll('.product__media-item'));
    var vignettes = [].slice.call(g.querySelectorAll('.thumbnail-list__item'));
    var tl = g.querySelector('.thumbnail-list');
    function activer(i, defiler) {
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      vignettes.forEach(function (t, k) {
        var b = t.querySelector('button'); if (!b) return;
        if (k === i) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
      });
      if (defiler && liste.scrollWidth > liste.clientWidth + 5) {
        liste.scrollTo({ left: slides[i].offsetLeft - liste.offsetLeft, behavior: 'smooth' });
      }
      if (tl && vignettes[i]) {
        tl.scrollTo({ left: vignettes[i].offsetLeft - tl.offsetLeft - tl.clientWidth / 2 + vignettes[i].clientWidth / 2, behavior: 'smooth' });
      }
    }
    vignettes.forEach(function (t, k) {
      var b = t.querySelector('button');
      if (b) b.addEventListener('click', function (e) { e.preventDefault(); activer(k, true); });
    });
    var minuterie;
    liste.addEventListener('scroll', function () {
      clearTimeout(minuterie);
      minuterie = setTimeout(function () {
        if (!slides.length) return;
        var w = slides[0].getBoundingClientRect().width || 1;
        var i = Math.max(0, Math.min(slides.length - 1, Math.round(liste.scrollLeft / w)));
        if (!slides[i].classList.contains('is-active')) activer(i, false);
      }, 90);
    });
    g.querySelectorAll('.thumbnail-slider .slider-button').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!tl) return;
        var pas = (vignettes[0] ? vignettes[0].getBoundingClientRect().width : 80) * 3;
        tl.scrollBy({ left: b.name === 'next' ? pas : -pas, behavior: 'smooth' });
      });
    });
  });

  /* ------------------------------------------------------------ offres (balisage Kaching) */
  var bloc = document.querySelector('.kaching-bundles');
  function offreChoisie() { return document.querySelector('.vt-vas .offer-box.active') || document.querySelector('.kaching-bundles__bar--selected') || document.querySelector('.kaching-bundles__bar'); }
  if (bloc) {
    bloc.querySelectorAll('.kaching-bundles__bar').forEach(function (bar) {
      bar.addEventListener('click', function () {
        bloc.querySelectorAll('.kaching-bundles__bar').forEach(function (b) { b.classList.toggle('kaching-bundles__bar--selected', b === bar); });
        var r = bar.querySelector('input'); if (r) r.checked = true;
      });
    });
  }

  /* ------------------------------------------------------------ panier */
  var tiroir = document.getElementById('vt-panier');
  var TX = {};
  try { TX = JSON.parse(tiroir.getAttribute('data-textes')); } catch (e) {}
  function ouvrir() {
    if (!tiroir) return;
    tiroir.classList.add('animate', 'active');
    document.body.classList.add('overflow-hidden');
  }
  function fermer() {
    if (!tiroir) return;
    tiroir.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
  }
  function bulle(n) {
    document.querySelectorAll('[data-vt-bulle]').forEach(function (b) {
      b.hidden = !n; var t = b.querySelector('span'); if (t) t.textContent = n;
    });
  }
  /* cadeaux de l'offre 3 (04/11/2026) : variantes à 0 € lues sur le formulaire du bloc d'offres (data-vt-regali…) */
  var FRG = document.querySelector('form[data-vt-regali]');
  var vtRegali = FRG ? FRG.getAttribute('data-vt-regali').split(',').filter(Boolean) : [];
  var vtRegaliVal = FRG ? (FRG.getAttribute('data-vt-regali-val') || '').split(',') : [];
  var vtRegaliMin = FRG ? parseInt(FRG.getAttribute('data-vt-regali-min') || '5', 10) : 5;
  var vtSonnevia = FRG ? (FRG.querySelector('[name="id"]') || {}).value : null;
  function estRegalo(it) { return vtRegali.indexOf(String(it.variant_id)) >= 0; }
  /* garde-fou : s'il reste moins de N flaconi (offre 3), les cadeaux quittent le panier */
  function garde(cart) {
    if (!cart || !cart.items || !vtRegali.length) return Promise.resolve(cart);
    var q = 0, regali = [];
    cart.items.forEach(function (it) { if (String(it.variant_id) === String(vtSonnevia)) q += it.quantity; if (estRegalo(it)) regali.push(it); });
    if (!regali.length || q >= vtRegaliMin) return Promise.resolve(cart);
    var upd = {}; regali.forEach(function (it) { upd[it.key] = 0; });
    return fetch(RACINE + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: upd }) })
      .then(function (r) { return r.json(); });
  }
  function rendre(cart) {
    if (!tiroir) return;
    var ul = tiroir.querySelector('[data-vt-lignes]');
    tiroir.classList.toggle('is-empty', !cart.item_count);
    var vide = tiroir.querySelector('.drawer__inner-empty');   /* Shrine ne rend ce bloc que si le panier est vide */
    if (vide) vide.hidden = !!cart.item_count;
    bulle(cart.item_count);
    var cmpVar = CFG.cmp || {};
    /* cadeaux de l'offre 3 sous les flaconi */
    var lignes = cart.items.slice().sort(function (x, y) { return (estRegalo(x) ? 1 : 0) - (estRegalo(y) ? 1 : 0); });
    ul.innerHTML = lignes.map(function (it, i) {
      var cmpU = Math.max(cmpVar[it.variant_id] || 0, it.original_price);
      var unite = Math.round(it.final_line_price / it.quantity);
      var cmpL = cmpU * it.quantity;
      var badges = (it.line_level_discount_allocations || []).map(function (d) {
        return '<div class="badge"><svg aria-hidden="true" focusable="false" class="icon icon-discount color-foreground-text" viewBox="0 0 12 12"><path fill-rule="evenodd" clip-rule="evenodd" d="M7 0h3a2 2 0 012 2v3a1 1 0 01-.3.7l-6 6a1 1 0 01-1.4 0l-4-4a1 1 0 010-1.4l6-6A1 1 0 017 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z" fill="currentColor"></path></svg> <span>' + esc(d.discount_application.title) + '</span></div>';
      }).join('');
      var img = it.image ? it.image.replace(/(\.\w+)(\?|$)/, '$1$2').split('?')[0] + '?width=300' : '';
      if (estRegalo(it)) {
        var val = parseInt(vtRegaliVal[vtRegali.indexOf(String(it.variant_id))] || '0', 10) || 0;
        var grat = (FRG && FRG.getAttribute('data-vt-regali-gratis')) || 'GRATIS';
        return '<li id="CartDrawer-Item-' + (i + 1) + '" class="cart-drawer-item cart-item vt-regalo" role="row" data-key="' + esc(it.key) + '" data-qte="' + it.quantity + '">' +
          '<div class="cart-item__media" role="cell">' + (img ? '<img class="cart-item__image" src="' + esc(img) + '" alt="" loading="lazy" width="150" height="150">' : '') + '</div>' +
          '<div class="cart-drawer-item__right"><div class="cart-drawer-item__details-and-delete-btn"><div class="cart-item__details" role="cell">' +
          '<span class="cart-item__name h4 break">' + esc(it.product_title) + '</span>' +
          '<div class="cart-item__discounted-prices cart-drawer-item__single-item-prices"><span>' + (val ? '<s class="cart-item__old-price product-option text-color-text">' + argent(val) + '</s> ' : '') +
          '<strong class="cart-item__final-price product-option text-color-accent-1">' + esc(grat) + '</strong></span></div>' +
          '</div></div><div class="cart-drawer-item__quantity-and-prices"><div class="cart-item__quantity"><span class="vt-regalo__qte">× ' + it.quantity + '</span></div>' +
          '<div class="cart-item__totals right" role="cell"><div class="cart-item__price-wrapper"><div class="cart-item__discounted-prices">' +
          (val ? '<s class="cart-item__old-price price--end compare-price color-foreground-text">' + argent(val * it.quantity) + '</s> ' : '') +
          '<span class="price--end regular-price accent-color-accent-1">' + esc(grat) + '</span></div></div></div></div></div></li>';
      }
      return '<li id="CartDrawer-Item-' + (i + 1) + '" class="cart-drawer-item cart-item" role="row" data-key="' + esc(it.key) + '" data-qte="' + it.quantity + '">' +
        '<div class="cart-item__media" role="cell">' + (img ? '<img class="cart-item__image" src="' + esc(img) + '" alt="" loading="lazy" width="150" height="150">' : '') + '</div>' +
        '<div class="cart-drawer-item__right"><div class="cart-drawer-item__details-and-delete-btn"><div class="cart-item__details" role="cell">' +
        '<a href="' + esc(it.url) + '" class="cart-item__name h4 break">' + esc(it.product_title) + '</a>' +
        '<div class="cart-item__discounted-prices cart-drawer-item__single-item-prices"><span>' +
        (cmpU > unite ? '<span class="visually-hidden">' + esc(TX.prix_listino) + '</span><s class="cart-item__old-price product-option text-color-text">' + argent(cmpU) + '</s> ' : '') +
        '<span class="visually-hidden">' + esc(TX.prix_sconto) + '</span><strong class="cart-item__final-price product-option text-color-accent-1">' + argent(unite) + '</strong></span>' +
        (badges ? '<div class="cart-drawer__discounts list-unstyled" role="list" aria-label="' + esc(TX.sconto) + '">' + badges + '</div>' : '') +
        '</div></div>' +
        '<cart-remove-button class="cart-drawer-item__cart-remove-button"><button type="button" class="button button--tertiary" data-vt-moins="all" aria-label="' + esc(TX.rimuovi) + '"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" focusable="false" class="icon icon-remove"><path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"></path><path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"></path></svg></button></cart-remove-button>' +
        '</div><div class="cart-drawer-item__quantity-and-prices cart-drawer-item__quantity-and-prices--has-props"><div class="cart-item__quantity"><div class="cart-item__quantity-wrapper">' +
        '<quantity-input class="quantity cart-quantity color-background-2 cart-quantity--round-btns" style="--font-size:1.2rem; --border-width:0.1rem; --border-color:#787878; --corner-radius:0.6rem; --container-padding:0em; --input-padding:0.6em; --separator-opacity:0.15; --padding:0.2em; --icon-size:0.7em;">' +
        '<button class="quantity__button quantity__button--minus color-background-2' + (it.quantity <= 1 ? ' disabled' : '') + '" name="minus" type="button" data-vt-moins="1"><svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 448 512"><path d="M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z"></path></svg></button>' +
        '<input class="quantity__input" type="number" value="' + it.quantity + '" min="1" readonly>' +
        '<button class="quantity__button quantity__button--plus color-background-2" name="plus" type="button" data-vt-plus="1"><svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 448 512"><path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 144L48 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0 0 144c0 17.7 14.3 32 32 32s32-14.3 32-32l0-144 144 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-144 0 0-144z"></path></svg></button>' +
        '</quantity-input></div></div>' +
        '<div class="cart-item__totals right" role="cell"><div class="cart-item__price-wrapper"><div class="cart-item__discounted-prices">' +
        (cmpL > it.final_line_price ? '<s class="cart-item__old-price price--end compare-price color-foreground-text">' + argent(cmpL) + '</s> ' : '') +
        '<span class="price--end regular-price accent-color-accent-1">' + argent(it.final_line_price) + '</span></div>' +
        (cmpL > it.final_line_price ? '<span class="cart-drawer-item__saving text-color-text"><strong>(' + esc(TX.risparmi) + ' ' + argent(cmpL - it.final_line_price) + ')</strong></span>' : '') +
        '</div></div></div></div></li>';
    }).join('');
    var paga = tiroir.querySelector('[data-vt-paga]');
    if (paga) paga.textContent = (TX.paga || '') + ' • ' + argent(cart.total_price);
  }
  function lire() { return fetch(RACINE + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function changer(cle, q) {
    return fetch(RACINE + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: cle, quantity: q }) })
      .then(function (r) { return r.json(); }).then(garde).then(rendre);
  }
  window.vtPanier = { ouvrir: ouvrir, fermer: fermer, lire: lire, rendre: rendre };
  if (tiroir) {
    tiroir.addEventListener('click', function (e) {
      if (e.target.closest('.drawer__close') || e.target.id === 'CartDrawer-Overlay' || e.target.closest('[data-vt-fermer]')) { e.preventDefault(); fermer(); return; }
      var li = e.target.closest('[data-key]'); if (!li) return;
      var q = parseInt(li.getAttribute('data-qte'), 10);
      if (e.target.closest('[data-vt-plus]')) changer(li.getAttribute('data-key'), q + 1);
      var m = e.target.closest('[data-vt-moins]');
      if (m) changer(li.getAttribute('data-key'), m.getAttribute('data-vt-moins') === 'all' ? 0 : Math.max(0, q - 1));
    });
    document.addEventListener('keyup', function (e) { if (e.key === 'Escape') fermer(); });
    lire().then(garde).then(rendre).catch(function () {});
  }
  document.querySelectorAll('a[href$="/cart"], a[href="' + RACINE + 'cart"], #cart-icon-bubble').forEach(function (a) {
    a.addEventListener('click', function (e) { if (!tiroir) return; e.preventDefault(); lire().then(rendre).then(ouvrir); });
  });

  /* ajout au carrello : la variante × N de l'offre choisie, une seule offre à la fois (la nouvelle remplace l'ancienne) */
  document.querySelectorAll('form[data-type="add-to-cart-form"]').forEach(function (f) {
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var bar = offreChoisie();
      var q = parseInt((bar && bar.getAttribute('data-vt-qte')) || '1', 10);
      var id = f.querySelector('[name="id"]').value;
      var btn = f.querySelector('[type="submit"]');
      if (btn) { btn.classList.add('loading'); btn.setAttribute('aria-disabled', 'true'); }
      var upd = {}; upd[id] = q;
      var regali = (f.getAttribute('data-vt-regali') || '').split(',').filter(Boolean);
      var conRegali = regali.length && bar && String(bar.getAttribute('data-tier')) === f.getAttribute('data-vt-regali-offre');
      regali.forEach(function (r) { upd[r] = 0; });   /* une seule offre à la fois : les cadeaux repartent de zéro */
      var hj = { 'Content-Type': 'application/json', Accept: 'application/json' };
      fetch(RACINE + 'cart/update.js', { method: 'POST', headers: hj, body: JSON.stringify({ updates: upd }) })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (!conRegali || !(cart && cart.items)) return cart;
          var props = {}; var pk = f.getAttribute('data-vt-regali-prop'); if (pk) props[pk] = f.getAttribute('data-vt-regali-propval') || '';
          return fetch(RACINE + 'cart/add.js', { method: 'POST', headers: hj, body: JSON.stringify({ items: regali.map(function (r) { return { id: parseInt(r, 10), quantity: 1, properties: props }; }) }) })
            .then(function () { return lire(); }, function () { return cart; });
        })
        .then(function (cart) {
          var pf = f.closest('product-form');
          var boite = (pf && pf.querySelector('.product-form__error-message-wrapper')) || f.querySelector('.vt-erreur');
          if (cart && cart.items) { if (boite) boite.hidden = true; rendre(cart); ouvrir(); return; }
          if (boite) { boite.hidden = false; var m = boite.querySelector('.product-form__error-message') || boite; m.textContent = (cart && (cart.description || cart.message)) || ''; }
        })
        .catch(function () { f.submit(); })
        .finally(function () { if (btn) { btn.classList.remove('loading'); btn.removeAttribute('aria-disabled'); } });
    });
  });

  /* ------------------------------------------------------------ en-tête : menu, recherche, collant au défilement vers le haut */
  document.querySelectorAll('header-drawer details, .menu-drawer-container').forEach(function (d) {
    var s = d.querySelector('summary'); if (!s || d._vt) return; d._vt = 1;
    function fermerMenu() { d.classList.remove('menu-opening'); document.body.classList.remove('overflow-hidden-tablet'); setTimeout(function () { d.removeAttribute('open'); }, 300); }
    s.addEventListener('click', function (e) {
      e.preventDefault();
      if (d.hasAttribute('open')) { fermerMenu(); return; }
      d.setAttribute('open', ''); document.body.classList.add('overflow-hidden-tablet');
      setTimeout(function () { d.classList.add('menu-opening'); }, 20);
    });
    d.querySelectorAll('.menu-drawer__close-btn').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); fermerMenu(); }); });
  });
  document.querySelectorAll('details-modal details').forEach(function (d) {
    var s = d.querySelector('summary'); if (!s) return;
    s.addEventListener('click', function (e) {
      e.preventDefault();
      if (d.hasAttribute('open')) { d.removeAttribute('open'); document.body.classList.remove('overflow-hidden'); }
      else { d.setAttribute('open', ''); document.body.classList.add('overflow-hidden'); var i = d.querySelector('input[type="search"]'); if (i) setTimeout(function () { i.focus(); }, 50); }
    });
    d.querySelectorAll('.modal-overlay').forEach(function (o) { o.addEventListener('click', function () { d.removeAttribute('open'); document.body.classList.remove('overflow-hidden'); }); });
  });
  var entete = document.querySelector('.section-header');
  var sticky = document.querySelector('sticky-header');
  if (entete && sticky && sticky.getAttribute('data-sticky-type') === 'on-scroll-up') {
    entete.classList.add('shopify-section-header-sticky');
    var avant = 0;
    window.addEventListener('scroll', function () {
      var y = window.pageYOffset;
      var h = entete.getBoundingClientRect().height;
      if (y > avant && y > entete.offsetTop + h) { entete.classList.add('shopify-section-header-hidden'); entete.classList.remove('animate'); }
      else if (y < avant) { entete.classList.remove('shopify-section-header-hidden'); if (y > h) entete.classList.add('animate'); else entete.classList.remove('animate'); }
      avant = y;
    }, { passive: true });
  }
})();
